import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const LawsuitCheckListView = (props) => {
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [results, setResults] = useState([]);
  const [results2, setResults2] = useState([]);
  const [final_check, setFinalCheck] = useState([]);
  const [superNote, setSuperNote] = useState("");
  const [superNote2, setSuperNote2] = useState("");
  const [superNote3, setSuperNote3] = useState("");

  const fetchResults = async () => {
    var body = {};

    var url =
      props.client.type === "sankcja kredytu darmowego"
        ? "https://apidevkppp.ftpeople.pl/getCheckOptionsLawsuitSKD"
        : "https://apidevkppp.ftpeople.pl/getCheckOptionsLawsuit";

    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setQuestions(data);
        var arr = [];
        var arr2 = [];
        if (props.client.checklist) {
          data.map((el, index) => {
            var check = JSON.parse(
              props.client.checklist
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replace(/\n/g, "\\\\n")
                .replace(/\r/g, "\\\\r")
                .replace(/\t/g, "\\\\t")
            );

            if (check.filter((e) => e.question === el.question).length > 0) {
              var newR = {
                index: index,
                question: check.filter((e) => e.question === el.question)[0]
                  .question,
                result: check.filter((e) => e.question === el.question)[0]
                  .result,
                note: check.filter((e) => e.question === el.question)[0].note,
              };
              arr.push(newR);
            }

            try {
              if (props.client.checklist2) {
                var check2 = JSON.parse(
                  props.client.checklist2
                    .replaceAll(/\\n/g, "\\n")
                    .replaceAll(/\\'/g, "\\'")
                    .replaceAll(/\\"/g, '\\"')
                    .replaceAll(/\\&/g, "\\&")
                    .replaceAll(/\\r/g, "\\r")
                    .replaceAll(/\\t/g, "\\t")
                    .replaceAll(/\\b/g, "\\b")
                    .replaceAll(/\\f/g, "\\f")
                    .replace(/\n/g, "\\\\n")
                    .replace(/\r/g, "\\\\r")
                    .replace(/\t/g, "\\\\t")
                );

                if (
                  check2.filter((e) => e.question === el.question).length > 0
                ) {
                  var newR = {
                    index: index,
                    note: check2.filter((e) => e.question === el.question)[0]
                      .note,
                    result: check2.filter((e) => e.question === el.question)[0]
                      .result,
                  };
                  arr2.push(newR);
                }
              }
            } catch (err) {}
          });
        }

        setResults(arr);
        setResults2(arr2);
        setFinalCheck(props.client.checklist3);
        setSuperNote(props.client.checklist4 ? props.client.checklist5 : "");
        setSuperNote2(props.client.checklist5 ? props.client.checklist4 : "");
        setSuperNote3(props.client.checklist6 ? props.client.checklist6 : "");
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleChangeAnswer = (res, id) => {
    var bool = false;
    if (results.length > 0) {
      results.map((el) => {
        if (+el.index === +id) {
          el.result = res;
          bool = true;
        }
      });
    }

    if (bool) {
      return;
    }
    results.push({ index: id, result: res, note: "" });
  };

  const handleChangeAnswer2 = (res, id) => {
    var bool = false;
    if (results2.length > 0) {
      results2.map((el) => {
        if (+el.index === +id) {
          el.result = res;
          bool = true;
        }
      });
    }

    if (bool) {
      return;
    }
    results2.push({ index: id, result: res, note: "" });
  };

  const handleChangeNote = (note, id) => {
    var bool = false;
    if (results.length > 0) {
      results.map((el) => {
        if (+el.index === +id) {
          el.note = note;
          bool = true;
        }
      });
    }

    if (bool) {
      return;
    }
    results.push({ index: id, result: "", note: note });
  };

  const save = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results.filter((r) => +r.index === +index)[0]
          ? results.filter((r) => +r.index === +index)[0].result
          : "",
        note: results.filter((r) => +r.index === +index)[0]
          ? results.filter((r) => +r.index === +index)[0].note
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: JSON.stringify(arr),
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "ankietę",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const save2 = async () => {
    setLoading(true);
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results.filter((r) => +r.index === +index)[0]
          ? results.filter((r) => +r.index === +index)[0].result
          : "",
        note: results.filter((r) => +r.index === +index)[0]
          ? results.filter((r) => +r.index === +index)[0].note
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: JSON.stringify(arr),
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklistClose", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
        var templateParams = {
          to:
            props.users.filter((el) => el.name === props.client.praw_spr_pozew)
              .length > 0
              ? props.users.filter(
                  (el) => el.name === props.client.praw_spr_pozew
                )[0].mail
              : "m.bialas@kppp.pl",
          reply_to: "",
          content: `W sprawie o ID: ${
            props.client.id_old
          } (${props.client.petitioner.replaceAll(
            "  ",
            ""
          )}) zakończono ankietę do pozwu. Proszę o sprawdzenie.`,
          subject: `W sprawie o ID: ${props.client.id_old} zakończono ankietę do pozwu. Proszę o sprawdzenie.`,
          user_name: props.client.praw_pozew,
        };

        emailjs.send("KPPP", "template_h43760d", templateParams).then(
          function (response) {
            MySwal.fire({
              icon: "success",
              title: "Zapisano",
              text: "ankietę",
            }).then(async (result) => {
              props.close();
            });
          },
          function (error) {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "nie wysłano wiadomości e-mail. Ponów operację!",
            }).then(async (result) => {
              props.close();
            });
          }
        );
      })
      .catch((error) => {});
  };

  const save3 = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].result
          : "",
        note: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].note
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: JSON.stringify(arr),
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const save5 = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].result
          : "",
        note: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].note
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: final_check,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist3", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const save4 = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].result
          : "",
        note: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].note
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: JSON.stringify(arr),
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist2Close", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const save6 = async () => {
    var arr = [];
    questions.map((el, index) => {
      var newR = {
        question: el.question,
        result: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].result
          : "",
        note: results2.filter((r) => +r.index === +index)[0]
          ? results2.filter((r) => +r.index === +index)[0].note
          : "",
      };
      arr.push(newR);
    });

    var body = {
      id: props.client.id,
      content: final_check,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClientChecklist3Close", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zapisano",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const open = async () => {
    var body = {
      id: props.client.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/openClientChecklistClose", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Otwarto",
          text: "ankietę",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const open2 = async () => {
    var body = {
      id: props.client.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/openClientChecklistClose2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Otwarto",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const open3 = async () => {
    var body = {
      id: props.client.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/openClientChecklistClose3", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Otwarto",
          text: "sprawdzenie",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const checkTable = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Do weryfikacji</th>
          <th>Sporządzający pozew</th>
          <th>Sprawdzający pozew - czy dane są prawidłowe</th>
        </tr>
        {results.map((el, index) => (
          <>
            <tr id={""} key={index}>
              <td>{index + 1}</td>
              <td style={{ fontSize: "1vw" }}>{el.question}</td>
              <td>
                {results.filter((r) => +r.index === +index)[0]
                  ? typeof results.filter((r) => +r.index === +index)[0]
                      .result === "boolean"
                    ? results.filter((r) => +r.index === +index)[0].result
                      ? "TAK"
                      : "NIE"
                    : results.filter((r) => +r.index === +index)[0].result
                  : "NIE UZUPEŁNIONO"}
              </td>
              <td>
                {results2.filter((r) => +r.index === +index)[0]
                  ? typeof results2.filter((r) => +r.index === +index)[0]
                      .result === "boolean"
                    ? results2.filter((r) => +r.index === +index)[0].result
                      ? "DOBRZE"
                      : "ŹLE"
                    : results2.filter((r) => +r.index === +index)[0].result
                  : " NIE UZUPEŁNIONO"}
              </td>
            </tr>
            <tr>
              <td style={{ fontSize: "1vw" }}>Notatka</td>
              <td colSpan="2" style={{ padding: "10px" }}>
                {results.filter((r) => +r.index === +index)[0]
                  ? results.filter((r) => +r.index === +index)[0].note
                  : "nie uzupełniono"}
              </td>
              <td colSpan="2" style={{ padding: "10px" }}>
                {results2.filter((r) => +r.index === +index)[0]
                  ? results2.filter((r) => +r.index === +index)[0].note
                  : " NIE UZUPEŁNIONO"}
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  return (
    <div
      style={{
        width: "100%",
        position: "relative",
        right: "auto",
        top: "auto",
        boxSizing: "border-box",
        boxShadow: "none",
      }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <p style={{ fontWeight: "900" }}>ANKIETA DO POZWU</p>
          {checkTable}

          <>
            <div className="inputBox">
              <div
                className="inputCol_1"
                style={{ width: "100%", minWidth: "100%" }}
              >
                <label>Notatka - sporządzający pozew</label>
                <p style={{ fontSize: "1vw" }}>{superNote2}</p>
              </div>
            </div>
            <div className="inputBox">
              <div
                className="inputCol_1"
                style={{ width: "100%", minWidth: "100%" }}
              >
                <label>Notatka - sprawdzający</label>
                <p style={{ fontSize: "1vw" }}>{superNote}</p>
              </div>
            </div>
            <div className="inputBox">
              <div
                className="inputCol_1"
                style={{ width: "100%", minWidth: "100%" }}
              >
                <label>Notatka - zadanie</label>
                <p style={{ fontSize: "1vw" }}>{superNote3}</p>
              </div>
            </div>
            <div className="inputBox">
              <div
                className="inputCol_1"
                style={{ width: "100%", minWidth: "100%" }}
              >
                <label>Notatka - finalne sprawdzenie</label>
                <p style={{ fontSize: "1vw" }}>{final_check}</p>
              </div>
            </div>
          </>
        </>
      )}
    </div>
  );
};

export default LawsuitCheckListView;
